import { RouteConfig } from 'vue-router'
import peKnowledgeIcon from '@/assets/images/icon_menu_pe_knowledge@2x.png'
import peKnowledgeActiveIcon from '@/assets/images/icon_menu_pe_knowledge_active@2x.png'
import KnowledgeRepoPage from '@/views/pe-knowledge/KnowledgeRepo.vue'
import KnowledgeExamDetailPage from '@/views/pe-knowledge/KnowledgeExamDetail.vue'
import KnowledgeExamListPage from '@/views/pe-knowledge/KnowledgeExamList.vue'
import KnowledgePracticeListPage from '@/views/pe-knowledge/KnowledgePracticeList.vue'
import KnowledgeExamClazzDetailPage from '@/views/pe-knowledge/KnowledgeExamClazzDetail.vue'
import KnowledgeExamStudentDetailPage from '@/views/pe-knowledge/KnowledgeExamStudentDetail.vue'
import KnowledgeExamResultForStudentPage from '@/views/pe-knowledge/KnowledgeExamResultForStudent.vue'
import KnowledgePracticeClazzDetailPage from '@/views/pe-knowledge/KnowledgePracticeClazzDetail.vue'
import KnowledgePracticeStudentDetailPage from '@/views/pe-knowledge/KnowledgePracticeStudentDetail.vue'
import PracticeStudentDetailPage from '@/views/special-skill/PracticeStudentDetail.vue'

const Layout = () => import('../views/Layout.vue')

export const PEKnowledgeRepoRoute: RouteConfig = {
  path: '/repo',
  name: 'pe_knowledge_repo',
  component: KnowledgeRepoPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识库',
    showMenu: true,
  },
}

export const PEKnowledgeExamDetailRoute: RouteConfig = {
  path: '/pe-knowledge-exam-detail',
  name: 'pe_knowledge_exam_detail',
  component: KnowledgeExamDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '知识库',
  },
}

export const PEKnowledgeExamListRoute: RouteConfig = {
  path: '/pe-knowledge-exam-list',
  name: 'pe_knowledge_exam_list',
  component: KnowledgeExamListPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '考试列表',
    showMenu: true,
  },
}

export const PEKnowledgeClazzDetailRoute: RouteConfig = {
  path: '/pe-knowledge-exam-clazz-detail',
  name: 'pe_knowledge_exam_clazz_detail',
  component: KnowledgeExamClazzDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '考试列表',
  },
}

export const PEKnowledgeStudentDetailRoute: RouteConfig = {
  path: '/pe-knowledge-exam-student-detail',
  name: 'pe_knowledge_exam_student_detail',
  component: KnowledgeExamStudentDetailPage,
  props: (route) => ({
    ...route.query,
    ...route.params,
    classId: +route.query.classId,
    clazzOption: JSON.parse(route.query.clazzOption as string),
  }),
  meta: {
    title: '考试列表',
  },
}

export const PEKnowledgeExamResultForStudentRoute: RouteConfig = {
  path: '/pe-knowledge-exam-result-student',
  name: 'pe_knowledge_exam_result_student',
  component: KnowledgeExamResultForStudentPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生答题详情',
  },
}

export const PEKnowledgePracticeListRoute: RouteConfig = {
  path: '/pe-knowledge-practice-list',
  name: 'pe_knowledge_practice_list',
  component: KnowledgePracticeListPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '练习列表',
    showMenu: true,
  },
}

export const PEKnowledgePracticeClazzDetailRoute: RouteConfig = {
  path: '/pe-knowledge-practice-clazz-detail',
  name: 'pe_knowledge_practice_clazz_detail',
  component: KnowledgePracticeClazzDetailPage,
  props: (route) => ({ ...route.query, ...route.params, training: JSON.parse(route.query.training as string) }),
  meta: {
    title: '练习列表',
  },
}

export const PEKnowledgePracticeStudentDetailRoute: RouteConfig = {
  path: '/pe-knowledge-practice-student-detail',
  name: 'pe_knowledge_practice_student_detail',
  component: KnowledgePracticeStudentDetailPage,
  props: (route) => ({
    ...route.query,
    ...route.params,
    training: JSON.parse(route.query.training as string),
    clazzOptions: JSON.parse(route.query.clazzOptions as string),
    challengeClassId: route.query.challengeClassId,
  }),
  meta: {
    title: '练习列表',
  },
}

export const PEKnowledgePracticeResultForStudentRoute: RouteConfig = {
  path: '/pe-knowledge-practice-student-result',
  name: 'pe_knowledge_practice_student_result',
  component: PracticeStudentDetailPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '练习列表',
  },
}

export const PEKnowledgeRoute: RouteConfig = {
  path: '/pe-knowledge',
  name: 'pe_knowledge',
  component: Layout,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育知识',
    showMenu: true,
    icon: peKnowledgeIcon,
    iconActive: peKnowledgeActiveIcon,
  },
  children: [
    PEKnowledgeRepoRoute,
    PEKnowledgeExamDetailRoute,
    PEKnowledgeExamListRoute,
    PEKnowledgeClazzDetailRoute,
    PEKnowledgeStudentDetailRoute,
    PEKnowledgeExamResultForStudentRoute,

    PEKnowledgePracticeListRoute,
    PEKnowledgePracticeClazzDetailRoute,
    PEKnowledgePracticeStudentDetailRoute,
    PEKnowledgePracticeResultForStudentRoute,
  ],
}

export default [PEKnowledgeRoute]
